import React, { useState, useEffect } from "react";
import { Modal } from "antd";
import toast from "react-hot-toast";
import { feature_unlock_request_email } from "../../Controllers/FeatureUnLockMail";
import { get_feature_status } from "../../Controllers/FeatureLock";

const FeatureUnlockRequestModal = ({
    isOpen,
    onClose,
    feature,
    onSuccess
}) => {
    const [featureData, setFeatureData] = useState(null);
    const [isProcessing, setIsProcessing] = useState(false);

    useEffect(() => {
        if (!feature) return;
        if (typeof feature === "object" && !Array.isArray(feature)) {
            setFeatureData(feature);
        }
        else if (typeof feature === "string") {
            checkFeatureStatus(feature);
        }
    }, [feature]);


    const checkFeatureStatus = async () => {
        try {
            const response = await get_feature_status({ feature_key: feature });

            if (response?.status) {
                setFeatureData(response.data?.feature || null);
            }
        } catch (error) {
            console.error("Error checking feature status:", error);
        }
    };

    const handleUnlock = async () => {
        if (!featureData || !featureData.id) {
            toast.error("Feature information is missing");
            return;
        }
        try {
            setIsProcessing(true);
            const response = await feature_unlock_request_email({
                feature_ids: [
                    featureData.id
                ],
            });

            if (response?.status) {
                toast.success(
                    `Request for "${featureData.name}" submitted successfully! Our admin will review it shortly and get back to you.`,
                    {
                       duration: 8000,  
                        pauseOnHover: true, 
                    }
                );
                if (onSuccess) onSuccess();
                if (onClose) onClose();
            } else {
                toast.error(response?.message || "Failed to Request feature");
            }
        } catch (error) {
            console.error("Request feature error:", error);
            toast.error("An error occurred while Requesting the feature");
        } finally {
            setIsProcessing(false);
        }
    };

    if (!featureData) {
        return null;
    }

    return (
        <Modal
            open={isOpen}
            onCancel={onClose}
            title={`Unlock: ${featureData.name}`}
            footer={null}
            centered
        >
            <div className="p-1">
                <div className="mb-4 p-4 bg-blue-50 rounded-lg">
                    <p className="text-sm text-blue-800 mb-2">
                        {featureData.description || "Unlock this premium feature"}
                    </p>
                    <p className="text-lg font-semibold text-blue-900">
                        Amount: {featureData.standalone_amount?.toFixed(2) || "0.00"}
                    </p>
                    {featureData.duration_days > 0 && (
                        <p className="text-sm text-blue-700 mt-1">
                            Valid for {featureData.duration_days} days
                        </p>
                    )}
                </div>

                <div className="space-y-4">
                    <div className="flex justify-end space-x-3 pt-4">
                        <button
                            type="button"
                            className="px-4 py-2 text-sm font-medium text-gray-700 bg-gray-100 rounded-md hover:bg-gray-200 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-gray-500 transition-colors"
                            onClick={onClose}
                            disabled={isProcessing}
                        >
                            Cancel
                        </button>
                        <button
                            type="button"
                            className="px-4 py-2 text-sm font-medium text-white bg-blue-600 rounded-md hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500 disabled:opacity-50 disabled:cursor-not-allowed transition-colors"
                            onClick={handleUnlock}
                            disabled={isProcessing}
                        >
                            {isProcessing ? "Requesting..." : "Request Feature"}
                        </button>
                    </div>
                </div>
            </div>
        </Modal>
    );
};

export default FeatureUnlockRequestModal;